import { Button, Grid, Typography } from '@mui/material';

type Props = {
  buttonLabel?: string;
  errorMessage: string;
  redirectMessage?: string;
  redirectUrl?: string;
};

export function ErrorMessage({
  buttonLabel = 'トップページに戻る',
  errorMessage,
  redirectMessage = 'トップページに戻るにはこちらをクリックしてください。',
  redirectUrl = '/',
}: Props) {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      rowSpacing={7}
      alignItems="center"
      sx={(theme) => ({
        minHeight: 'calc(100vh - 90px)', //114px Footer Height + Header Height
      })}
    >
      <Grid item>
        <Typography
          variant="xxxl"
          sx={() => ({
            fontWeight: 'bold',
          })}
        >
          {errorMessage}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="md">{redirectMessage}</Typography>
      </Grid>
      <Grid item>
        <Button
          variant="primary"
          onClick={() => (window.location.href = redirectUrl)}
        >
          {buttonLabel}
        </Button>
      </Grid>
    </Grid>
  );
}
